import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e17d029a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "prize-box"
};
const _hoisted_2 = {
  class: "prize-tips"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 提示：卡牌将自动进入");
const _hoisted_4 = /*#__PURE__*/_createTextVNode("，点击");
const _hoisted_5 = {
  class: "content-box"
};
const _hoisted_6 = {
  class: "prize-card"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  class: "canvas",
  id: "pag"
}, null, -1));
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 0,
  class: "num-icon"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btns_tip"
}, "未拆包前请勿退出此页，否则系统会自动拆包哦", -1));
const _hoisted_11 = {
  class: "prize-tips"
};
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 提示：卡牌将自动进入");
const _hoisted_13 = /*#__PURE__*/_createTextVNode("，点击");
const _hoisted_14 = {
  class: "prize-card-list"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "level"
};
const _hoisted_17 = {
  key: 1,
  class: "content-box"
};
const _hoisted_18 = {
  class: "prize-card"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  class: "canvas",
  id: "pag"
}, null, -1));
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 0,
  class: "num-icon"
};
const _hoisted_22 = {
  key: 0,
  class: "btns_tips_treasure"
};
const _hoisted_23 = /*#__PURE__*/_createTextVNode("商家积分");
const _hoisted_24 = {
  class: "color"
};
const _hoisted_25 = /*#__PURE__*/_createTextVNode("送你一个");
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "积分宝箱", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  class: "canvas_bg",
  id: "pag_bg"
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fixed-btn"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_CompBox = _resolveComponent("CompBox");
  const _component_CompCardImg = _resolveComponent("CompCardImg");
  const _component_van_list = _resolveComponent("van-list");
  const _component_CompBack = _resolveComponent("CompBack");
  const _component_CompEWM = _resolveComponent("CompEWM");
  const _component_CompPriviewImg = _resolveComponent("CompPriviewImg");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [$data.ifFirst && $data.is_next ? (_openBlock(), _createBlock(_component_CompBox, {
    key: 0
  }, _createSlots({
    title: _withCtx(() => [_createTextVNode(_toDisplayString($data.card_info.extract_card_name) + " ", 1), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = (...args) => $options.goUserCollect && $options.goUserCollect(...args))
    }, "图鉴"), _hoisted_4, _createElementVNode("span", {
      onClick: _cache[1] || (_cache[1] = (...args) => $options.goContainer && $options.goContainer(...args))
    }, "申请发货")])]),
    content: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("img", {
      src: _ctx.$imgUrlFilter($data.card_info.extract_card_icon, 620)
    }, null, 8, _hoisted_8), $data.card_info.extract_card_pack_total - $data.alreadyNum > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "x" + _toDisplayString($data.card_info.extract_card_pack_total - $data.alreadyNum), 1)) : _createCommentVNode("", true)])])]),
    _: 2
  }, [$data.player1 && $data.player2 ? {
    name: "btns",
    fn: _withCtx(() => [_hoisted_10, _createElementVNode("div", {
      class: "btns",
      onClick: _cache[2] || (_cache[2] = $event => $options.draw('2'))
    })])
  } : undefined]), 1024)) : (_openBlock(), _createBlock(_component_CompBox, {
    key: 1,
    type: "gray"
  }, _createSlots({
    content: _withCtx(() => [$data.list && $data.list.length ? (_openBlock(), _createBlock(_component_van_list, {
      key: 0,
      loading: $data.loading,
      "onUpdate:loading": _cache[7] || (_cache[7] = $event => $data.loading = $event),
      "immediate-check": false,
      onLoad: $options.onLoad
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['card-item', {
            'card-item-last': (index + 1) % 3 == 0
          }]),
          onClick: $event => $options.showImgPreview(index)
        }, [_createVNode(_component_CompCardImg, {
          src: _ctx.$imgUrlFilter(item.card_icon, 400)
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_16, _toDisplayString(item.level_name), 1)], 10, _hoisted_15);
      }), 128))])]),
      _: 1
    }, 8, ["loading", "onLoad"])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("img", {
      src: _ctx.$imgUrlFilter($data.card_info.extract_card_icon, 620)
    }, null, 8, _hoisted_20), $data.card_info.extract_card_pack_total > 1 && $data.is_next ? (_openBlock(), _createElementBlock("div", _hoisted_21, "x" + _toDisplayString($data.card_info.extract_card_pack_total - $data.alreadyNum), 1)) : _createCommentVNode("", true)])]))]),
    btns: _withCtx(() => [$data.shop_point && Number($data.shop_point) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [$data.shop_point ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_hoisted_23, _createElementVNode("span", _hoisted_24, "+" + _toDisplayString($data.shop_point), 1)], 64)) : _createCommentVNode("", true), $data.point_box_msg ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_hoisted_25, _hoisted_26], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.player1 && $data.player2 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("div", {
      class: "btns_2 btns_2_01",
      onClick: _cache[8] || (_cache[8] = (...args) => $options.goCardsDetail && $options.goCardsDetail(...args))
    }, "继续抽卡"), $data.shop_point && Number($data.shop_point) > 0 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "btns_2 btns_2_02",
      onClick: _cache[9] || (_cache[9] = _withModifiers($event => $options.goTreasure($event), ["stop"])),
      "data-clipboard-action": "copy"
    }, "查看宝箱")) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "btns_2 btns_2_02",
      onClick: _cache[10] || (_cache[10] = (...args) => $options.onShare && $options.onShare(...args))
    }, "分享"))], 64)) : _createCommentVNode("", true)]),
    _: 2
  }, [$data.list && $data.list.length ? {
    name: "title",
    fn: _withCtx(() => [_createTextVNode(" 恭喜获得" + _toDisplayString($data.total) + "张 ", 1), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", {
      onClick: _cache[3] || (_cache[3] = (...args) => $options.goUserCollect && $options.goUserCollect(...args))
    }, "图鉴"), _hoisted_13, _createElementVNode("span", {
      onClick: _cache[4] || (_cache[4] = (...args) => $options.goContainer && $options.goContainer(...args))
    }, "申请发货")])])
  } : {
    name: "title",
    fn: _withCtx(() => [_createTextVNode(_toDisplayString($data.card_info.extract_card_name) + " ", 1), _createElementVNode("div", {
      class: "prize-tips"
    }, [_createTextVNode(" 提示：卡牌将自动进入"), _createElementVNode("span", {
      onClick: _cache[5] || (_cache[5] = (...args) => $options.goUserCollect && $options.goUserCollect(...args))
    }, "图鉴"), _createTextVNode("，点击"), _createElementVNode("span", {
      onClick: _cache[6] || (_cache[6] = (...args) => $options.goContainer && $options.goContainer(...args))
    }, "申请发货")])])
  }]), 1024)), _hoisted_27, !$data.env.isWxApp() ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "back",
    onClick: _cache[11] || (_cache[11] = (...args) => $options.goBack && $options.goBack(...args))
  })) : _createCommentVNode("", true), _createVNode(_component_CompBack, {
    show: $data.show,
    "onUpdate:show": _cache[12] || (_cache[12] = $event => $data.show = $event),
    onCheckoutAll: $options.checkoutAll
  }, null, 8, ["show", "onCheckoutAll"]), _hoisted_28, _createVNode(_component_CompEWM, {
    show: $data.showEWM,
    "onUpdate:show": _cache[13] || (_cache[13] = $event => $data.showEWM = $event)
  }, null, 8, ["show"]), _createVNode(_component_CompPriviewImg, {
    show: $data.showPreImg,
    "onUpdate:show": _cache[14] || (_cache[14] = $event => $data.showPreImg = $event),
    list: $data.list,
    "img-index": $data.imgIndex
  }, null, 8, ["show", "list", "img-index"])]));
}